import { render, staticRenderFns } from "./ButtonRemove.html?vue&type=template&id=a8130c08&scoped=true&"
import script from "./ButtonFavoriteRemove.vue?vue&type=script&lang=ts&"
export * from "./ButtonFavoriteRemove.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonFavoriteRemove.vue?vue&type=style&index=0&id=a8130c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8130c08",
  null
  
)

export default component.exports